/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

const coreApi = coreService.tournamentsApi;
export const getCoreUpcomingTournaments = 'core-upcoming-tournaments';
export const getCorePastTournaments = 'core-past-tournaments';
const getCoreTournamentUsersLeaderboard = 'core-tournament-users-leaderboard';
const getCoreTournamentResults = 'core-tournaments-results';

export const useGetCoreUpcomingTournaments = (token: string, isTournamentGamePackageEnabled: boolean) => {
    return useQuery([getCoreUpcomingTournaments, token], () => coreApi.getUpcomingTournaments(token), {
        cacheTime: 0,
        enabled: !!token && isTournamentGamePackageEnabled
    });
};

export const useGetCorePastTournaments = (token: string, isTournamentGamePackageEnabled: boolean) => {
    return useQuery([getCorePastTournaments, token], () => coreApi.getPastTournaments(token), {
        cacheTime: 0,
        enabled: !!token && isTournamentGamePackageEnabled,
        keepPreviousData: true
    });
};

export const useGetCoreTournamentUsersLeaderboard = ({
    token,
    enableQuery,
    offset,
    limit,
    searchString,
    tournamentUuid
}: {
    token: string;
    enableQuery: boolean;
    offset: number;
    limit: number;
    searchString?: string;
    tournamentUuid?: string;
}) => {
    return useQuery(
        [getCoreTournamentUsersLeaderboard, { token, offset, limit, tournamentUuid, searchString }],
        () =>
            coreApi.getStatisticsLeaderboard(
                token,
                tournamentUuid || '',
                { offset, limit, searchString },
                { isAdmin: false }
            ),
        {
            cacheTime: 0,
            keepPreviousData: true,
            enabled: enableQuery && Boolean(tournamentUuid) && !!token
        }
    );
};

export const useGetCoreTournamentResult = (
    token: string,
    tournamentUuid: string,
    isTournamentGamePackageEnabled: boolean
) => {
    return useQuery([getCoreTournamentResults, token], () => coreApi.getTournamentResults(token, tournamentUuid), {
        cacheTime: 0,
        enabled: !!token && !!tournamentUuid && isTournamentGamePackageEnabled
    });
};
